module.exports = "/_next/static/images/ki-1e425fd5f0963cc828dbc2f7501ee394.svg";